import React, { Component } from 'react';
import Cube from './Cube';
import fenderSaleImage from './assets/fender.jpg';
import learnToPlayImage from './assets/learn-to-play-live.png';
import newMartinsImage from './assets/martin.jpg';
import casioImage from './assets/casio.jpg';
import signImage from './assets/sign.jpg';
import logosImage from './assets/logos.jpg';
import ukulelesImage from './assets/ukuleles.png';
import './styles.css';

export default class CubeGrid extends Component {

  componentWillMount() {

    this.setState({
      cubes: [
        {
          image: signImage,
          imageAlt: "We've been selling fun since 1971"
        },
        {
          image: learnToPlayImage,
          imageAlt: 'We offer private lessons for guitar, bass, drums, ukulele, banjo, and mandolin',
          size: 2,
          target: {
            route: '/lessons'
          }
        },
        {
          image: logosImage,
          imageAlt: 'logos for the brands that McGuire sells',
          size: 2
        },
        {
          image: casioImage,
          imageAlt: 'McGuire sells Casio keyboards'
        },
        {
          image: fenderSaleImage,
          imageAlt: 'Come in to the McGuire Music Fender sale'
        },
        {
          image: newMartinsImage,
          imageAlt: 'we have new Martin guitars in stock'
        },
        {
          image: ukulelesImage,
          imageAlt: 'McGuire Music sells Ukuleles'
        },
        // {
        //   image: keyboardsImage,
        //   imageAlt: 'We have keyboards'
        // },
        // HACK: Blank SVG for spacing.
        // {
        //   image: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg"/>',
        //   size: 2,
        // },

      ]
    });
  }

  render() {
    return(
      <div className="cube-grid">
        {this.state.cubes.map(this._renderCube)}
      </div>
    );
  }

  _renderCube = (cube, index) => {

    const containerClass = cube.size === 2 ? 'cube-container-two' : 'cube-container-one';
    return (
      <div className={containerClass} key={index}>
        <div className="aspect-ratio-container">
          <Cube {...cube}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CubeGrid/index.js